var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_91",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.659,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 129.659 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.77936,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 6.77936 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.539,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 252.539 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.099,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 191.099 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.2194,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 68.2194 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.379,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 160.379 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4994,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 37.4994 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.259,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 283.259 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.819,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 221.819 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.9394,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 98.9394 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.019,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 145.019 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1394,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 22.1394 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.899,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 267.899 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.459,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 206.459 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5793,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 83.5793 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.739,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 175.739 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8594,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 52.8594 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.619,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 298.619 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.179,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 237.179 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.299,
    y: -35.9998,
    width: 5.12,
    height: 256,
    transform: "rotate(45 114.299 -35.9998)",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripes);
export default __webpack_public_path__ + "static/media/stripes.1234994f655cd903bee35ddfad08f6e6.svg";
export { ForwardRef as ReactComponent };